import { useState } from "react";
import axios from "axios";
import { logout } from "../../utils/logout";

let isRedirecting = false;

const usePost = (url) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const postData = async (body) => {
    const token = JSON.parse(sessionStorage.getItem("userData"));
    const access_token = token ? token.access_token : null;
    setError(null);
    try {
      setLoading(true);
      const response = await axios.post(url, body, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      setData(response?.data);
    } catch (err) {
      // Handle 401 errors
      if (err.response?.status === 401 && !isRedirecting) {
        isRedirecting = true;
        logout();
      }
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, postData };
};

export default usePost;
